__turbopack_context__.v({
  "changeEmailActions": "CUserAccounts-module__0Yu3SG__changeEmailActions",
  "dangerButton": "CUserAccounts-module__0Yu3SG__dangerButton",
  "dangerZone": "CUserAccounts-module__0Yu3SG__dangerZone",
  "dangerZoneText": "CUserAccounts-module__0Yu3SG__dangerZoneText",
  "dangerZoneTitle": "CUserAccounts-module__0Yu3SG__dangerZoneTitle",
  "empty": "CUserAccounts-module__0Yu3SG__empty",
  "fieldRow": "CUserAccounts-module__0Yu3SG__fieldRow",
  "form": "CUserAccounts-module__0Yu3SG__form",
  "formHint": "CUserAccounts-module__0Yu3SG__formHint",
  "formTitle": "CUserAccounts-module__0Yu3SG__formTitle",
  "linkButton": "CUserAccounts-module__0Yu3SG__linkButton",
  "logoutForm": "CUserAccounts-module__0Yu3SG__logoutForm",
  "primaryButton": "CUserAccounts-module__0Yu3SG__primaryButton",
  "profileAvatar": "CUserAccounts-module__0Yu3SG__profileAvatar",
  "profileAvatarButton": "CUserAccounts-module__0Yu3SG__profileAvatarButton",
  "profileAvatarImg": "CUserAccounts-module__0Yu3SG__profileAvatarImg",
  "profileAvatarInitials": "CUserAccounts-module__0Yu3SG__profileAvatarInitials",
  "profileAvatarOverlay": "CUserAccounts-module__0Yu3SG__profileAvatarOverlay",
  "profileEmptyHint": "CUserAccounts-module__0Yu3SG__profileEmptyHint",
  "profileForm": "CUserAccounts-module__0Yu3SG__profileForm",
  "profileFormActions": "CUserAccounts-module__0Yu3SG__profileFormActions",
  "profileLayout": "CUserAccounts-module__0Yu3SG__profileLayout",
  "profileLayoutCollapsed": "CUserAccounts-module__0Yu3SG__profileLayoutCollapsed",
  "profileMain": "CUserAccounts-module__0Yu3SG__profileMain",
  "profileSectionFields": "CUserAccounts-module__0Yu3SG__profileSectionFields",
  "profileSidebar": "CUserAccounts-module__0Yu3SG__profileSidebar",
  "profileSidebarBadge": "CUserAccounts-module__0Yu3SG__profileSidebarBadge",
  "profileSidebarCollapseToggle": "CUserAccounts-module__0Yu3SG__profileSidebarCollapseToggle",
  "profileSidebarColumn": "CUserAccounts-module__0Yu3SG__profileSidebarColumn",
  "profileSidebarError": "CUserAccounts-module__0Yu3SG__profileSidebarError",
  "profileSidebarHeader": "CUserAccounts-module__0Yu3SG__profileSidebarHeader",
  "profileSidebarHeaderEmail": "CUserAccounts-module__0Yu3SG__profileSidebarHeaderEmail",
  "profileSidebarHeaderInfo": "CUserAccounts-module__0Yu3SG__profileSidebarHeaderInfo",
  "profileSidebarHeaderName": "CUserAccounts-module__0Yu3SG__profileSidebarHeaderName",
  "profileSidebarLogoutBtn": "CUserAccounts-module__0Yu3SG__profileSidebarLogoutBtn",
  "profileSidebarLogoutIcon": "CUserAccounts-module__0Yu3SG__profileSidebarLogoutIcon",
  "profileSidebarNav": "CUserAccounts-module__0Yu3SG__profileSidebarNav",
  "profileSidebarNavIcon": "CUserAccounts-module__0Yu3SG__profileSidebarNavIcon",
  "profileSidebarNavItem": "CUserAccounts-module__0Yu3SG__profileSidebarNavItem",
  "profileSidebarNavItemActive": "CUserAccounts-module__0Yu3SG__profileSidebarNavItemActive",
  "profileSidebarNavItemDisabled": "CUserAccounts-module__0Yu3SG__profileSidebarNavItemDisabled",
  "profileSidebarNavItemPlugin": "CUserAccounts-module__0Yu3SG__profileSidebarNavItemPlugin",
  "profileSidebarNavLabel": "CUserAccounts-module__0Yu3SG__profileSidebarNavLabel",
  "profileSubTab": "CUserAccounts-module__0Yu3SG__profileSubTab",
  "profileSubTabActive": "CUserAccounts-module__0Yu3SG__profileSubTabActive",
  "profileSubTabContent": "CUserAccounts-module__0Yu3SG__profileSubTabContent",
  "profileSubTabs": "CUserAccounts-module__0Yu3SG__profileSubTabs",
  "root": "CUserAccounts-module__0Yu3SG__root",
  "tab": "CUserAccounts-module__0Yu3SG__tab",
  "tabActive": "CUserAccounts-module__0Yu3SG__tabActive",
  "tabs": "CUserAccounts-module__0Yu3SG__tabs",
  "welcomeCard": "CUserAccounts-module__0Yu3SG__welcomeCard",
  "welcomeMeta": "CUserAccounts-module__0Yu3SG__welcomeMeta",
  "welcomeText": "CUserAccounts-module__0Yu3SG__welcomeText",
});
